// extracted by mini-css-extract-plugin
export default {"container":"Jp-z","bubbleNav":"Kp-z","graphic":"Lp-z","contact":"Mp-z"};